/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.modalModule', ['mm.foundation', 'bulbApp.configModule', 'bulbApp.translateModule',
  'bulbApp.utilsModule'])
.constant('MODAL_ARIA', {
  OpenDialogList:[],
  Utils: {
    IgnoreUtilFocusChanges:false,
    dialogOpenClass:'has-dialog'
  },
  // this constant will synchronize modal opening and closing callbacks.
  MODAL_TIMEOUT : 100,
  AERO_DIALOG_KEY : 'aero-dialog'
})
.run(['$rootScope', 'MODAL_ARIA', function($rootScope, MODAL_ARIA) {
  $rootScope.MODAL_ARIA = MODAL_ARIA;
}]);
